export const RECONNECT_BASE_MS = 1000;
export const RECONNECT_CAP_MS = 30000;
export const RECONNECT_JITTER_MS = 1000;
export const SNAPSHOT_MAX_AGE_MS = 6000;
export const RESYNC_JITTER_MS = 4000;
export const RESYNC_RETRY_MIN_MS = 5000;
export const RESYNC_RETRY_JITTER_MS = 5000;
export const RESYNC_RETRY_LIMIT = 3;
export const PROBE_SILENCE_MS = 25000;
export const PROBE_TIMEOUT_MS = 10000;
export const WAKE_HIDDEN_MS = 30000;
export const CONNECTING_STALL_MS = 10000;
export const LIVE_COUNT_DEBOUNCE_MS = 2000;
export const LIVE_COUNT_JITTER_MS = 13000;
export const LIST_RETURN_MAX_AGE_S = 10;
export const EVENT_REQUEST_DEDUPE_MS = 3000;

export const randomDelay = (spread: number, random: () => number = Math.random) => Math.floor(random() * spread);

export const reconnectDelay = (attempt: number, random: () => number = Math.random) =>
  Math.min(RECONNECT_CAP_MS, RECONNECT_BASE_MS * 2 ** attempt) + randomDelay(RECONNECT_JITTER_MS, random);

export const openResyncDelay = (random: () => number = Math.random) =>
  SNAPSHOT_MAX_AGE_MS + randomDelay(RESYNC_JITTER_MS, random);

export const resyncRetryDelay = (random: () => number = Math.random) =>
  RESYNC_RETRY_MIN_MS + randomDelay(RESYNC_RETRY_JITTER_MS, random);

export const snapshotSince = (startedAt: number, openedAt?: number) =>
  (openedAt === undefined ? startedAt : Math.max(startedAt - SNAPSHOT_MAX_AGE_MS, openedAt));

const isEmptyMap = (value: unknown) =>
  value !== null && typeof value === 'object' && Object.keys(value as object).length === 0;

export const isEmptyRateReply = (message: object) => {
  const { command, count, alias, mainline, additional } = message as Record<string, unknown>;
  return command === 'rate'
    && Number(count) === 0
    && alias === ''
    && isEmptyMap(mainline)
    && (additional === undefined || isEmptyMap(additional));
};
